import React from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
	RiUserLine,
	RiShieldCheckLine,
	RiMapPinLine,
	RiBankLine,
	RiNotification3Line,
	RiFileTextLine,
	RiLogoutBoxRLine,
} from "@remixicon/react";
import PageHeader from "../common/PageHeader";
import LinkList from "../common/LinkList";
import { logout } from "../../store/authSlice";

// Mirrors ordr-flutter's Controls tab (lib/home/controls/control_screen.dart).
export default function Controls() {
	const { summary } = useOutletContext() || {};
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const items = [
		{ to: "/settings", icon: RiUserLine, label: "Edit profile", text: "Your name, photo and contact details" },
		{ to: "/company-verification", icon: RiShieldCheckLine, label: "Company details & verification", text: "Controller, ownership and documents" },
		{ to: "/locations", icon: RiMapPinLine, label: "Manage delivery locations", text: "Your fueling sites" },
		{ to: "/funds", icon: RiBankLine, label: "Manage funding methods", text: "Your connected accounts" },
		{
			to: "/notifications",
			icon: RiNotification3Line,
			label: "Notifications",
			text: "Order and bid alerts",
			badge: summary?.unreadNotifications || null,
		},
		{ to: "/terms-of-service", icon: RiFileTextLine, label: "User agreement" },
		{ to: "/privacy-policy", icon: RiFileTextLine, label: "Privacy policy" },
	];

	return (
		<div style={{ maxWidth: 720 }}>
			<PageHeader title="Controls" subtitle="Manage your account, company and locations" />
			<LinkList items={items} />
			<div className="card mt-3">
				<button
					type="button"
					className="settings-link logout"
					onClick={() => {
						dispatch(logout());
						navigate("/login");
					}}
				>
					<span className="settings-link-icon">
						<RiLogoutBoxRLine size={18} />
					</span>
					<span className="flex-grow-1 fw-semibold">Log out</span>
				</button>
			</div>
		</div>
	);
}
